import store from '../store/index'
export const HEADERS = { headers: { 'Content-Type': 'application/json' } }
export let AUTH_HEADERS = function () {
  let headers = { 'Content-Type': 'application/json' }
  if (store.state.auth && store.state.auth.accessToken) {
    headers['Authorization'] = `Bearer ${store.state.auth.accessToken}`
  }
  return { headers, timeout: 10000 }
}
export let AUTH_HEADERS_BLOB = function () {
  let headers = { 'Content-Type': 'multipart/form-data' }
  if (store.state.auth && store.state.auth.accessToken) {
    headers['Authorization'] = `Bearer ${store.state.auth.accessToken}`
  }
  return { headers, timeout: 30000, responseType: 'blob' }
}
export let AUTH_HEADERS_FORM_DATA = function () {
  let headers = {}
  if (store.state.auth && store.state.auth.accessToken) {
    headers['Authorization'] = `Bearer ${store.state.auth.accessToken}`
  }
  return { headers }
}
export let AUTH_HEADERS_DROPZONE = function () {
  let authorization = ''
  if (store.state.auth && store.state.auth.accessToken) {
    authorization = `Bearer ${store.state.auth.accessToken}`
  }
  return authorization
}
